export default "__VITE_ASSET__09666e99__"